// Extract product/sku for karte

function getImagePath(premium: any) {
  let imgUrl = "";
  premium?.premiumimage_set?.forEach((img: any) => {
    if (img?.is_primary == true) {
      imgUrl = img?.image_url;
    }
  });

  return imgUrl;
}

export default function karteItem(product: any, quantity: number) {
  console.log("karteItem: ", product, quantity);
  try {
    const { id, name, sku_set, premiumimage_set, categories } = product;
    const itemUrl = window.location.origin + "/product-details/?id=" + id;
    const itemImageUrl = getImagePath(premiumimage_set);

    const category = categories && categories.length > 0 ? categories[0] : {};

    const item: any = {
      item_id: id + "",
      name: name,
      price: sku_set[0].point_required,
      item_url: itemUrl,
      item_image_url: itemImageUrl
      // brand: "brandA",
      // brand_cd: "branda",
      // favorite_num: 52,
      // review_num: 30,
      // stock_status: true,
    };

    if (quantity > 0) {
      item.quantity = quantity;
    }

    if (category && category.main_category) {
      item["l_category_name"] = category.main_category.name;
      item["l_category_cd"] = category.main_category.id + "";
    }

    if (
      category &&
      category.sub_categories &&
      category.sub_categories.length > 0
    ) {
      item["s_category_name"] = category.sub_categories[0].name;
      item["s_category_cd"] = category.sub_categories[0].id + "";
    }

    return item;
  } catch (e) {
    console.log("karte item: ", e);
  }

  return {};
}
